import {Injectable} from '@angular/core';
import {QueryBuilderConfigProvider} from '@common/filter/query-builder-config-provider';
import {FormDefinition, FormFieldDefinition} from '@feature/_app_modules/dynamic-forms/dynamic-form';
import {addFilterFieldsToAdminForm, WidgetAdminHandler} from '@feature/widget-admin';
import {WidgetConfiguration} from '@feature/widget-configs';
import {forkJoin, map, Observable} from 'rxjs';
import {
  AdminDebtorAccountHistoryWidgetFilterFieldProvider
} from '../filters/admin-debtor-account-history-widget-filter-field-provider';
import {WidgetDefaultColumnHandlerService} from './widget-default-column-handler.service';
import {
  DebtorAccountHistoryWidgetConfigService
} from "@feature/_app_modules/debtor-account-history-widget/services/debtor-account-history-widget-config.service";

@Injectable({
  providedIn: 'root'
})
export class DebtorAccountHistoryWidgetAdminHandler implements WidgetAdminHandler {

  constructor(
    private readonly defaultColumnAdminHandler: WidgetDefaultColumnHandlerService,
    private readonly widgetConfigService: DebtorAccountHistoryWidgetConfigService)
  { }

  initialise(): boolean | Observable<boolean> {
    return true;
  }
  getAdminForm(selectedConfig: WidgetConfiguration): FormDefinition | Observable<FormDefinition> {
    const getWidgetConfig = this.widgetConfigService.getAdminWidgetConfig(selectedConfig.id);
    const getAdminForm = this.defaultColumnAdminHandler.getAdminForm(selectedConfig) as Observable<FormDefinition>;
    return forkJoin([getAdminForm, getWidgetConfig])
      .pipe(map(([formDefinition, widgetConfig]) => {
        const filterFieldProvider = new AdminDebtorAccountHistoryWidgetFilterFieldProvider(selectedConfig);
        const queryConfigProvider = new QueryBuilderConfigProvider(filterFieldProvider);
        const queryConfig = queryConfigProvider.getQueryBuilderConfig();

        formDefinition = addFilterFieldsToAdminForm(selectedConfig, queryConfig, formDefinition);

        // position the sequence selection before the filters
        const sequenceFormField: FormFieldDefinition = {
          key: 'Sequence',
          label: 'Item sequence',
          type: 'debtor-account-history-widget-sequence-selection',
          value: widgetConfig.Sequence
        } as FormFieldDefinition;
        const filterFieldIndex = formDefinition.fields.findIndex(x => x.key === 'filter');
        formDefinition.fields.splice(filterFieldIndex, 0, sequenceFormField);

        return formDefinition;
      }))
  }

  createCopyFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.widgetConfigService.createCopyOfAdminWidgetConfig(selectedConfig, adminFormValue)
      .pipe(map(_ => true));
  }

  deleteConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.defaultColumnAdminHandler.deleteConfigFromAdminForm(selectedConfig, adminFormValue);
  }

  saveConfigFromAdminForm(selectedConfig: WidgetConfiguration, adminFormValue: any): Observable<boolean> {
    return this.widgetConfigService.saveAdminWidgetConfig(selectedConfig, adminFormValue)
      .pipe(map(_ => true));
  }
}
